// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { getFormSyncErrors } from 'redux-form'

import { actionTypes } from 'actions/actionTypes'
import * as trackingKeys from 'actions/trackingKeys'
import { CheckoutActionCreator } from 'routes/Checkout/models/ReduxTypes'

export const trackingOrderPlaceAttemptFailed: CheckoutActionCreator =
  () => (dispatch, getState) => {
    const errorMessages = getFormSyncErrors('payment')(getState()).payment

    dispatch({
      type: actionTypes.CHECKOUT_ORDER_PLACE_ATTEMPT_FAILED,
      trackingData: {
        actionType: trackingKeys.placeOrderFailAttempt,
        missing_fields:
          typeof errorMessages === 'object' ? Object.values(errorMessages) : undefined,
      },
    })
  }
